export default "__VITE_ASSET__95e967cd__"